'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _regulatorAddForm = require('./regulator-add-form.html');

var _regulatorAddForm2 = _interopRequireDefault(_regulatorAddForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _regulatorAddForm2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    regulator: '<',
    dialogTitle: '@',
    submitTitle: '@',
    onRegulatorChanged: '&'
  },
  controller: function () {
    function RegulatorAddFormComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, RegulatorAddFormComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(RegulatorAddFormComponent, [{
      key: 'onSubmit',
      value: function onSubmit() {
        this.onRegulatorChanged(this.EventEmitter({
          regulator: this.regulator
        }));
      }
    }]);

    return RegulatorAddFormComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/admin/regulator/regulator-add-form/regulator-add-form.component.js